// El informe entrega estas horas listas para mostrar, aunque lleven el sufijo Z.
// Usar UTC conserva la hora recibida sin aplicar la zona horaria del navegador.
export function formatCashClosingTime(value) {
  if (!value) return "N/A";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "N/A";
  return date.toLocaleString("es-CO", {
    timeZone: "UTC",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  });
}
